import { render } from "./RenovaNavegacao.vue?vue&type=template&id=79b02f36&scoped=true"
import script from "./RenovaNavegacao.vue?vue&type=script&lang=js"
export * from "./RenovaNavegacao.vue?vue&type=script&lang=js"

import "./RenovaNavegacao.vue?vue&type=style&index=0&id=79b02f36&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b02f36"]])

export default __exports__